import axios from 'axios'
import cookie from 'react-cookies'
import qs from 'query-string'
import { LOGIN_API_URL } from '@/constants/apiRoutes'
import { ACCESS_TOKEN_COOKIE } from '@/constants/names'
import {
  acquireRefreshLock,
  releaseRefreshLock,
  waitForRefreshLock,
  notifyAccessTokenUpdated,
} from '@/helpers/axios/oauthRefreshLock'

let refreshPromise = null

function getRefreshErrorMessage(error) {
  const data = error?.response?.data
  if (!data) {
    return ''
  }
  return String(
    data.errorMessage
    || data.error
    || data.message
    || data.error_description
    || '',
  )
}

function isRefreshRejected(error) {
  if (error?.isRefreshRejected) {
    return true
  }
  const status = error?.response?.status
  if (status === 400 || status === 401) {
    return true
  }
  if (status != null) {
    const message = getRefreshErrorMessage(error)
    if (/refresh_token/i.test(message)) {
      return true
    }
  }
  return false
}

async function postRefreshToken() {
  await waitForRefreshLock()

  const lockId = acquireRefreshLock()
  try {
    const response = await axios.post(
      LOGIN_API_URL,
      qs.stringify({ grant_type: 'refresh_token' }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Basic ${window.btoa('gateway:gateway')}`,
        },
        withCredentials: true,
      },
    )

    if (response.data?.error) {
      const err = new Error(response.data.error)
      err.isRefreshRejected = true
      throw err
    }

    const { access_token: accessToken, expires_in: expiresIn } = response.data
    if (accessToken) {
      cookie.save(ACCESS_TOKEN_COOKIE, accessToken, { path: '/' })
    }
    if (expiresIn != null) {
      cookie.save('lifeTime', expiresIn)
      cookie.save('startTime', new Date().getTime())
    }
    notifyAccessTokenUpdated(accessToken)

    return response.data
  } finally {
    releaseRefreshLock(lockId)
  }
}

/**
 * Single-flight refresh: parallel 401 handlers and tabs share one token request.
 */
export function refreshAccessToken() {
  if (!refreshPromise) {
    refreshPromise = postRefreshToken()
      .catch((error) => {
        if (isRefreshRejected(error) || error.isRefreshRejected) {
          const rejected = new Error('refresh_token_rejected')
          rejected.isRefreshRejected = true
          throw rejected
        }
        throw error
      })
      .finally(() => {
        refreshPromise = null
      })
  }
  return refreshPromise
}

export { isRefreshRejected }
